import React from 'react';
import { Button } from './ui/button';
import { Play, Calendar, MessageCircle } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-red-900/20"></div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Main Headline */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Inspiring Hearts Through
            <span className="bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">
              {" "}Gospel Music
            </span>
          </h1>
          
          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Experience the divine power of worship with Nadja Scott & Divine Anointing choir. 
            Professional gospel performances and complete church event coordination.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <a 
              href="https://docs.google.com/forms/d/12hphFMKBt-Zd44mV26mRSBOZkxx0veNAx_E3yN2YRw8/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 text-lg rounded-full flex items-center gap-2 min-w-[200px]">
                <Calendar className="w-5 h-5" />
                Connect with Us!
              </Button>
            </a>
          </div>
          
          {/* Featured Artist Photo */}
          <div className="relative max-w-3xl mx-auto">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/v63ww1ae_IMG_2049.jpg"
                alt="Nadja Scott - Divine Anointing"
                className="w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6 text-white">
                <p className="text-xl font-bold">Nadja Scott</p>
                <p className="text-sm opacity-90">Lead Artist & Choir Director</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Floating Chat Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <Button className="bg-green-600 hover:bg-green-700 text-white p-4 rounded-full shadow-lg">
          <MessageCircle className="w-6 h-6" />
        </Button>
      </div>
    </section>
  );
};